import 'swiper/css/bundle'
import Swiper from 'swiper/bundle'
import property from './modules/property'

property(document.querySelectorAll('[data-property]'))

// Desktop window scrolling for tuck-away nav
const headerElement = document.querySelector('[data-header]')
const heroContent = document.querySelector('[data-hero-content]')
const headerLogo = document.querySelector('[data-header-logo]')
const mainHeaderUl = document.querySelector('[data-main-header]')
const mobileHam = document.querySelector('[data-ham]')
const mobileNoHam = document.querySelector('[data-noham]')
const mobileNavContent = document.querySelector('[data-mobile-nav-content]')
const mobileDropdown = document.querySelector('[data-mobile-nav-content]')

const headerNavWrappers = document.querySelectorAll('[data-nav-wrapper]')
const mobileDropdownTriggers = document.querySelectorAll('[data-mobile-nav]')
const fullPageScrollers = document.querySelectorAll('[data-full-scroller]')
const logoScrollers = document.querySelectorAll('[data-logos-scroller]')
const blogScrollers = document.querySelectorAll('[data-blog-scroller]')
const peopleFilters = document.querySelectorAll('[data-people-filters]')
const formContainers = document.querySelectorAll('[data-form]')

if (headerElement instanceof HTMLElement) {
    let lastScrollTop = 0 // variable to store the last scroll position

    window.addEventListener('scroll', () => {
        let scrollTop = window.scrollY || document.documentElement.scrollTop // current scroll position

        // set the header data attribute data-header-style value to "collapsed"
        const headerStyle = headerElement.attributes.getNamedItem('data-header-style')

        if (headerStyle) {
            headerStyle.value = 'collapsed'
        }

        if (scrollTop > lastScrollTop
            && mainHeaderUl instanceof HTMLElement
            && mobileNavContent instanceof HTMLElement) {
            // Scrolling down
            headerElement.style.maxHeight = '100px'
            headerElement.style.paddingTop = '10px'
            headerElement.style.backgroundColor = 'rgb(255 255 255 / 0.95)'
            mainHeaderUl.style.alignItems = 'center'

            Array.from(headerNavWrappers).forEach(headerNavWrapper => {
                const headerNavLinks = headerNavWrapper.querySelectorAll('a')
                const headerNavButtons = headerNavWrapper.querySelectorAll('button')

                if (headerNavLinks) {
                    Array.from(headerNavLinks).forEach(headerNavLink => {
                        if (!headerNavLink.classList.contains('button')) {
                            headerNavLink.style.color = '#000'
                        }
                    })
                }

                if (headerNavLinks) {
                    Array.from(headerNavButtons).forEach(headerNavButton => {
                        headerNavButton.style.color = '#000'
                    })
                }
            })

            if (heroContent && heroContent.classList.contains('opacity-0')) {
                heroContent.classList.remove('opacity-0')
            }

            // find the data-ham
            if (mobileHam) {
                const mobileHamPaths = mobileHam.querySelectorAll('path')

                Array.from(mobileHamPaths).forEach(mobileHamPath => {
                    mobileHamPath.style.fill = '#000'
                })
            }

            // find the data-noham
            if (mobileNoHam) {
                const mobileNoHamPaths = mobileNoHam.querySelectorAll('path')

                Array.from(mobileNoHamPaths).forEach(mobileNoHamPath => {
                    mobileNoHamPath.style.fill = '#000'
                })
            }

            // find the data-mobile-nav-content
            // convert the background of the mobile nav to white
            mobileNavContent.style.background = '#fff'
            //
            // Find all the buttons and links inside and convert them to black
            const mobileNavLinks = mobileNavContent.querySelectorAll('a')
            const mobileNavButtons = mobileNavContent.querySelectorAll('button')

            if (mobileNavLinks) {
                Array.from(mobileNavLinks).forEach(mobileNavLink => {
                    mobileNavLink.style.color = '#000'
                })
            }

            if (mobileNavButtons) {
                Array.from(mobileNavButtons).forEach(mobileNavButton => {
                    mobileNavButton.style.color = '#000'
                })
            }
        }

        if (scrollTop === 0
            && headerLogo instanceof HTMLElement
            && mainHeaderUl instanceof HTMLElement
            && headerElement instanceof HTMLElement
            && mobileHam instanceof HTMLElement
            && mobileNoHam instanceof HTMLElement
            && mobileNavContent instanceof HTMLElement) {
            headerElement.removeAttribute('style')
            headerLogo.removeAttribute('style')
            mainHeaderUl.removeAttribute('style')

            const headerStyleAttr = headerElement.attributes.getNamedItem('data-header-style')

            if (headerStyleAttr) {
                headerStyleAttr.value = 'normal'
            }

            Array.from(headerNavWrappers).forEach(headerNavWrapper => {
                const headerNavLinks = headerNavWrapper.querySelectorAll('a')
                const headerNavButtons = headerNavWrapper.querySelectorAll('button')

                if (headerNavLinks) {
                    Array.from(headerNavLinks).forEach(headerNavLink => {
                        headerNavLink.removeAttribute('style')
                    })
                }

                if (headerNavLinks) {
                    Array.from(headerNavButtons).forEach(headerNavButton => {
                        headerNavButton.removeAttribute('style')
                    })
                }
            })

            // find the data-ham
            // find the data-noham
            // convert the data-ham and data-noham svg paths to fill with white instead of black
            const mobileHamPaths = mobileHam.querySelectorAll('path')
            const mobileNoHamPaths = mobileNoHam.querySelectorAll('path')

            Array.from(mobileHamPaths).forEach(mobileHamPath => {
                // check if window is below 900px
                if (window.innerWidth >= 900) {
                    mobileHamPath.style.fill = '#fff'
                }
            })
            Array.from(mobileNoHamPaths).forEach(mobileNoHamPath => {
                if (window.innerWidth >= 900) {
                    mobileNoHamPath.style.fill = '#fff'
                }
            })

            // find the data-mobile-nav-content

            // remove the style attribute from the mobile nav content
            mobileNavContent.removeAttribute('style')

            // Find all the buttons and links inside and convert them to black
            const mobileNavLinks = mobileNavContent.querySelectorAll('a')
            const mobileNavButtons = mobileNavContent.querySelectorAll('button')

            if (mobileNavLinks) {
                Array.from(mobileNavLinks).forEach(mobileNavLink => {
                    // remove the style attribute
                    mobileNavLink.removeAttribute('style')
                })
            }

            if (mobileNavButtons) {
                Array.from(mobileNavButtons).forEach(mobileNavButton => {
                    // remove the style attribute
                    mobileNavButton.removeAttribute('style')
                })
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop // Update lastScrollTop to current position
    })
}

// Mobile nav dropdowns
for (const mobileDropdownTrigger of mobileDropdownTriggers) {
    const ham = mobileDropdownTrigger.querySelector('[data-ham]')
    const close = mobileDropdownTrigger.querySelector('[data-noham]')

    if (mobileDropdown
        && ham instanceof HTMLElement
        && close instanceof HTMLElement
        && heroContent instanceof HTMLElement) {
        mobileDropdownTrigger.addEventListener('click', () => {
            ham.classList.toggle('hidden')
            close.classList.toggle('hidden')
            mobileDropdown.classList.toggle('hidden')
            heroContent.classList.toggle('opacity-0')
        })
    }
}

// Card carousels
for (const scroller of fullPageScrollers) {
    if (scroller instanceof HTMLElement && scroller.parentElement instanceof HTMLElement) {
        const controls = scroller.parentElement.querySelector('[data-controls]')
        const nextEl = controls?.querySelector('[data-swiper-button-next]')
        const prevEl = controls?.querySelector('[data-swiper-button-prev]')

        /** @type {?Swiper} */
        let swiper = null

        /** @param {HTMLElement} el */
        function initSwiper(el) {
            swiper = new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: {
                    nextEl: nextEl instanceof HTMLElement ? nextEl : null,
                    prevEl: prevEl instanceof HTMLElement ? prevEl : null,
                },
                loop: true,
                autoplay: {
                    delay: 4000,
                    pauseOnMouseEnter: true,
                },
            })
        }

        /** @param {HTMLElement} el */
        function handleResize(el) {
            if (window.innerWidth >= 1024 && swiper === null) {
                initSwiper(el) // Initialize Swiper if the screen is 768px or wider
            } else if (window.innerWidth < 1024 && swiper !== null) {
                swiper.destroy(false, true) // Destroy Swiper if the screen is less than 768px
                swiper = null // Set swiper instance to null
            }
        }

        // Initialize or destroy Swiper on load
        handleResize(scroller)

        // Add event listener to handle resize
        window.addEventListener('resize', () => handleResize(scroller))
    }
}

// Logos carousels
for (const scroller of logoScrollers) {
    if (scroller instanceof HTMLElement && scroller.parentElement instanceof HTMLElement) {
        const controls = scroller.parentElement.querySelector('[data-controls]')
        const nextEl = controls?.querySelector('[data-swiper-button-next]')
        const prevEl = controls?.querySelector('[data-swiper-button-prev]')

        new Swiper(scroller, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            navigation: {
                nextEl: nextEl instanceof HTMLElement ? nextEl : null,
                prevEl: prevEl instanceof HTMLElement ? prevEl : null,
            },
            loop: true,
        })
    }
}

// Blog carousels
for (const scroller of blogScrollers) {
    if (scroller instanceof HTMLElement && scroller.parentElement instanceof HTMLElement) {
        const controls = scroller.parentElement.querySelector('[data-controls]')
        const nextEl = controls?.querySelector('[data-swiper-button-next]')
        const prevEl = controls?.querySelector('[data-swiper-button-prev]')

        new Swiper(scroller, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            navigation: {
                nextEl: nextEl instanceof HTMLElement ? nextEl : null,
                prevEl: prevEl instanceof HTMLElement ? prevEl : null,
            },
            loop: true,
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true,
            },
        })
    }
}

// People filters
for (const peopleFilter of peopleFilters) {
    const filterButtons = peopleFilter.querySelectorAll('button')
    const peopleCards = peopleFilter.querySelectorAll('[data-group]')

    if (filterButtons) {
        Array.from(filterButtons).forEach(filterButton => {
            filterButton.addEventListener('click', event => {
                // Find any open filters and close them
                Array.from(filterButtons).forEach(filterButton => filterButton.classList.remove('active'))
                // Find any open data target containers and close them
                Array.from(peopleCards).forEach(peopleCard => peopleCard.classList.add('hidden'))

                if (event.target instanceof HTMLElement) {
                    const filter = event.target.getAttribute('data-target')

                    // Add active class to clicked filter
                    event.target.classList.add('active')

                    for (const peopleCard of peopleCards) {
                        if (peopleCard.getAttribute('data-group') === filter) {
                            peopleCard.classList.remove('hidden')
                        } else {
                            peopleCard.classList.add('hidden')
                        }
                    }
                }
            })
        })
    }
}

// Only add shadows to form containers when they are next siblings of heros
for (const formContainer of formContainers) {
    const previousSibling = formContainer.previousElementSibling

    if (previousSibling && previousSibling.hasAttribute('data-hero')) {
        formContainer.classList.add('shadow-box-shadow')
        formContainer.classList.add('pt-[40px]')
    }
}
